import { supabase } from '@/lib/supabase';
import { ProjectWithContractors } from '@/shared/types/api';

export interface ProjectWithMemberCount extends ProjectWithContractors {
  member_count: number;
}

export const getUserProjects = async (): Promise<ProjectWithMemberCount[]> => {
  const { data, error } = await supabase.rpc(
    'get_user_projects_with_member_count',
  );

  if (error) {
    throw error;
  }

  return (data as unknown as ProjectWithMemberCount[]).map((project) => ({
    ...project,
    contractors: project.contractors.filter(
      (contractor, index, self) =>
        index === self.findIndex((t) => t.id === contractor.id),
    ),
  }));
};
